/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Status_DownloadingInputs */



/**
* | output |
* | --- |
* | "Downloading whisper model..." |
*
* @param {Offline_Sync_Status_DownloadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_status_downloading = /** @type {((inputs?: Offline_Sync_Status_DownloadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Status_DownloadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Téléchargement du modèle whisper...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Whisper-Modell wird heruntergeladen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Download modello whisper...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка модели whisper...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descargando modelo whisper...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在下载 whisper 模型...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Whisperモデルをダウンロードしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("व्हिस्पर मॉडल डाउनलोड हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A transferir modelo whisper...")
	return /** @type {LocalizedString} */ ("Downloading whisper model...")
});